import React from 'react';
import { FormattedMessage } from 'react-intl';

const InsuredAmountLabel = () => (
  <FormattedMessage defaultMessage='Insure Amt.' description='fulfillmentPlanner.insuredAmount' id='l7WiTG' />
);

export default InsuredAmountLabel;
